// Custom Flycher brand mark — circular ocean badge with stylized paper-plane + contrail
export const FlycherMark = ({ size = 36, className = "" }) => (
  <span
    className={`relative inline-flex items-center justify-center flex-shrink-0 ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="flycherGrad" x1="0" y1="0" x2="40" y2="40">
          <stop offset="0%" stopColor="#2A7FB8" />
          <stop offset="55%" stopColor="#3FA0D9" />
          <stop offset="100%" stopColor="#5FB3E3" />
        </linearGradient>
        <linearGradient id="flycherShine" x1="0" y1="0" x2="0" y2="40">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Outer badge with soft inner ring */}
      <circle cx="20" cy="20" r="19" fill="url(#flycherGrad)" />
      <circle cx="20" cy="20" r="19" fill="url(#flycherShine)" />
      <circle
        cx="20"
        cy="20"
        r="17"
        stroke="#ffffff"
        strokeOpacity="0.35"
        strokeWidth="0.6"
        fill="none"
      />

      {/* Dotted contrail arc — bottom-left to mid */}
      <path
        d="M9 28 Q 14 24 19 22"
        stroke="#ffffff"
        strokeOpacity="0.55"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeDasharray="0.4 2.3"
        fill="none"
      />

      {/* Paper-plane mark, tilted upward toward top-right */}
      <g transform="translate(13 11) rotate(-12)">
        <path
          d="M0 7 L17 0 L13 18 L8.5 10.5 Z"
          fill="#ffffff"
        />
        <path
          d="M8.5 10.5 L13 18 L11 12.5 Z"
          fill="#FFD7A8"
        />
        <path
          d="M0 7 L8.5 10.5 L13 5 Z"
          fill="#FFD7A8"
          opacity="0.65"
        />
      </g>

      {/* Tiny coral spark for travel/sun accent */}
      <circle cx="32" cy="9" r="1.4" fill="#FF7E4D" />
    </svg>
  </span>
);

// Full lockup: mark + wordmark with subtle contrail underline
export const FlycherLogo = ({ size = 36, theme = "dark" }) => {
  const textColor = theme === "dark" ? "text-slate-900" : "text-white";
  const dotColor = "#FF7E4D";
  return (
    <span className="flex items-center gap-2.5 group">
      <FlycherMark size={size} />
      <span className="flex flex-col leading-none">
        <span
          className={`font-serif text-[26px] tracking-tight ${textColor}`}
          style={{ letterSpacing: "-0.01em" }}
        >
          Flycher
        </span>
        <span className="mt-1 flex items-center gap-1.5">
          <span
            className="h-[2px] w-7 rounded-full"
            style={{
              background:
                "linear-gradient(to right, rgba(42,127,184,0.7), rgba(42,127,184,0))",
            }}
          />
          <span
            className="w-1 h-1 rounded-full"
            style={{ background: dotColor }}
          />
          <span className="text-[9px] tracking-[0.32em] uppercase font-semibold text-slate-500">
            Travel · AI
          </span>
        </span>
      </span>
    </span>
  );
};
